import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  ViewChild,
  ElementRef,
  Input,
  SimpleChanges,
} from "@angular/core";
import { Subscription } from "rxjs";
import { PharmaDataService } from "../pharma-data.service";
import { FilterEventChanged } from "src/app/store/actions/pharma-page.actions";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { AppService } from "src/app/app.service";
@Component({
  selector: "app-database-facet-selected-filters",
  templateUrl: "./database-facet-selected-filters.component.html",
  host: { class: "facet-selected-filter-container" },
  styleUrls: ["./database-facet-selected-filters.component.scss"],
})
export class DatabaseFacetSelectedFiltersComponent
  implements OnInit, OnDestroy, OnChanges
{
  @ViewChild("facetFiltersPills", { static: true })
  facetFiltersPillsRef!: ElementRef;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  isViewMore = false;
  tagCount = 0;
  tags = [];
  pillData;
  pillsDataSubscriber: Subscription;
  showBtnViewMore = false;
  isChildHeightSet = false;
  initialChildHeight: number;
  @Input() siderCollapsed: boolean;
  constructor(
    private service: PharmaDataService,
    private store: Store<AppState>,
    private appService: AppService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.siderCollapsed) {
      setTimeout(() => {
        this.updateViewMoreFlag();
      }, 250);
    }
  }

  ngOnInit() {
    // this.isOverflowing = false;
    this.pillsDataSubscriber = this.store
      .select(stateGetter("pharmaDatabasePage", "pillsData"))
      .subscribe((data: any) => {
        // same object returns true, not same then false
        this.pillData = data;
        const isTagsSame = this.appService.compare(
          this.tags,
          [...data.tags].reverse(),
        );
        if (isTagsSame) {
          return;
        }
        this.tags = [...data.tags].reverse();
        setTimeout(() => {
          this.updateViewMoreFlag();
        }, 150);
      });
  }

  updateViewMoreFlag() {
    const childDiv =
      this.facetFiltersPillsRef.nativeElement.querySelector(".tags-div");
    const parentW = this.facetFiltersPillsRef.nativeElement
      .querySelector("#facet-selected-filters")
      .getBoundingClientRect().width;
    const childW = childDiv.getBoundingClientRect().width;

    const childH = childDiv.getBoundingClientRect().height;

    if (childH !== 0 && !this.isChildHeightSet) {
      this.isChildHeightSet = true;
      this.initialChildHeight = childH;
    }

    if (childW >= parentW) {
      this.showBtnViewMore = true;
    } else {
      this.showBtnViewMore = false;
      this.isViewMore = false;
    }
  }
  toggleViewMore() {
    this.isViewMore = !this.isViewMore;
  }

  handleClose(tagToClose) {
    this.tags = this.tags.filter((tag) => {
      return !(
        tag["key"] === tagToClose["key"] && tag["id"] === tagToClose["id"]
      );
    });
    this.store.dispatch(
      new FilterEventChanged({
        filterChanged: "pill",
        source: "delete",
        pillInfo: { ...tagToClose, extraInfo: this.pillData["extraInfo"] },
      }),
    );
    if (tagToClose["key"] === "include_terminated") {
      this.tags = this.tags.filter((tag) => {
        return !(tag["key"] === "commercial_status" && tag["id"] === 7);
      });
      this.store.dispatch(
        new FilterEventChanged({
          filterChanged: "pill",
          source: "delete",
          pillInfo: { id: 7, key: "commercial_status", label: "Discontinued" },
        }),
      );
    }
  }

  ngOnDestroy() {
    if (this.pillsDataSubscriber) {
      this.pillsDataSubscriber.unsubscribe();
    }
  }
}
